import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  id: number;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toasts = signal<ToastMessage[]>([]);
  private nextId = 0;

  readonly messages = this.toasts.asReadonly();

  show({ message, durationMs = 3200, className = '' }: { message: string; durationMs?: number; className?: string; }): void {
    const id = this.nextId++;
    this.toasts.update((current) => [...current, { id, message }]);

    window.setTimeout(() => {
      this.dismiss(id);
    }, durationMs);
  }

  dismiss(id: number): void {
    this.toasts.update((current) => current.filter((toast) => toast.id !== id));
  }
}
